export default __webpack_public_path__ + "static/media/modal-body.813a29bc.svg";